// extracted by mini-css-extract-plugin
export default {"UnderlineLink":"UnderlineLink__UnderlineLink___CRLlg","light":"UnderlineLink__light___xrMku","dark":"UnderlineLink__dark___kOFj_"};